export const ADDONS_ACTIONS = {
    DELETE: 'delete',
    SAVE: 'save',
    SEARCH: 'search',
    FETCH_ACTION: 'normal'
}